import { createAction, props } from '@ngrx/store';

export const BreadcrumbSetUuidLabelAction = createAction('breadcrumb-set-uuid-label', props<{ uuidLabel: string }>());
